const WEB_FONTS = [
  { name: 'Inter', family: 'Inter:ital,wght@0,100..900;1,100..900' },
  {
    name: 'Roboto',
    family: 'Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900',
  },
  {
    name: 'Lato',
    family: 'Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900',
  },
  { name: 'Open Sans', family: 'Open+Sans:ital,wght@0,300..800;1,300..800' },
  { name: 'Nunito', family: 'Nunito:ital,wght@0,200..1000;1,200..1000' },
];

export const BRAND_FONTS = ['system-ui', 'Arial', ...WEB_FONTS.map((font) => font.name)];

export function getBrandFont(name: string | undefined): {
  font_family: string;
  stylesheet_url?: string;
} {
  const font = WEB_FONTS.find((option) => option.name === name);

  if (font) {
    return {
      font_family: `"${font.name}", system-ui, sans-serif`,
      stylesheet_url: `https://fonts.googleapis.com/css2?family=${font.family}&display=swap`,
    };
  }

  return {
    font_family: name === 'Arial' ? 'Arial, sans-serif' : 'system-ui, sans-serif',
  };
}
